import React, { useContext } from 'react';
import { useFormContext } from 'react-hook-form';

import { NCRContext } from 'views';
import { UserContext } from 'components/routing';

import { TextArea } from 'components/form/prototypes';
import { Asterisk } from 'components/form/prototypes';

const ReturnReason = () => {
  const { state } = useContext(NCRContext);
  const { user } = useContext(UserContext);
  const { register } = useFormContext();

  const isDisabled = ['QA', 'GM'].includes(user.role)
    ? state.ncr.status.id > 8
    : state.ncr.status.id > 1;

  return (
    <>
      {state.ncr.return.returnItems.length > 0 && <Asterisk />}
      <TextArea
        name="ncr.return.return_reason"
        label="Reason for Return"
        className={'full-span-text-area'}
        ref={register({ required: true })}
        disabled={isDisabled}
      />
    </>
  );
};

export { ReturnReason };
